module.exports = __webpack_public_path__ + "static/media/hollow_bar_WPC_tall.0166883f.svg";